/**  Strip all non-digits, then insert x if there are more than 10 digits */
export const stripPhoneNumberMask = (value?: string | null) => {
  if (!value) return "";

  // Strip all non-digits
  const digits = value.replace(/\D/g, "");

  // If more than 10 digits, insert x after the 10th digit
  if (digits.length > 10) {
    return `${digits.slice(0, 10)}x${digits.slice(10)}`;
  }

  return digits;
};
